export default "__VITE_ASSET__CWkiXFkF__"